module.exports = __webpack_public_path__ + "img/I-27.7754ce49.svg";